<template>
  <div class="container" id="container">
    <a href="https://www.funifelt.com/" target="_blank"><img src="@/assets/images/Logo_Funifelt_Blanco.png" class="logo"></a>

    <div class="unidadContenedor" id="unidadContenedor"> 
      
      <router-link :to="{ name: 'unidad', params: { unidad: 'unidad-0', diapositiva: '1' } }">
        <div class="botonUnidad"> 
          <div class="portada">
            <img src="@/assets/images/unidades/unidad-0.png">
          </div>
          <div class="titulo">
            Unidad 0 - Introducción
          </div>
          <div class="estado">
            Disponible
          </div>
        </div>
      </router-link>
      
      <router-link :to="{ name: 'unidad', params: { unidad: 'unidad-1', diapositiva: '1' } }">
        <div class="botonUnidad"> 
          <div class="portada">
            <img src="@/assets/images/unidades/unidad-1.png">
          </div>
          <div class="titulo">
            Unidad 1 - Vocales
          </div>
          <div class="estado">
            Disponible
          </div>
        </div>
      </router-link>

      <router-link :to="{ name: 'unidad', params: { unidad: 'unidad-2', diapositiva: '1' } }">
        <div class="botonUnidad"> 
          <div class="portada">
            <img src="@/assets/images/unidades/unidad-2.png">
          </div>
          <div class="titulo">
            Unidad 2 - Diptongo
          </div>
          <div class="estado">
            Disponible
          </div>
        </div>
      </router-link>

      <router-link :to="{ name: 'unidad', params: { unidad: 'unidad-3', diapositiva: '1' } }">
        <div class="botonUnidad"> 
          <div class="portada">
            <img src="@/assets/images/unidades/unidad-3.png">
          </div>
          <div class="titulo">
            Unidad 3 - Tildes y Acentuación
          </div>
          <div class="estado">
            Disponible
          </div>
        </div>
      </router-link>

      <router-link :to="{ name: 'unidad', params: { unidad: 'unidad-4', diapositiva: '1' } }">
        <div class="botonUnidad"> 
          <div class="portada">
            <img src="@/assets/images/unidades/unidad-4.png">
          </div>
          <div class="titulo">
            Unidad 4 - Hiatos
          </div>
          <div class="estado">
            Disponible
          </div>
        </div>
      </router-link>



      <!-- No se ha completado -->
      <div class="botonUnidad-b" @click="showPopup()"> 
        <div class="portada">
          <img src="@/assets/images/unidades/unidad-5.png">
        </div>
        <div class="titulo">
          Unidad 5 - Triptongos y Uso de la Y
        </div>
        <div class="estado">
          Bloqueado
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill" viewBox="0 0 16 16">
            <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
          </svg>
        </div>
      </div>

      

      <div class="botonUnidad-b" @click="showPopup()"> 
        <div class="portada">
          <img src="@/assets/images/unidades/unidad-6.png">
        </div>
        <div class="titulo">
          Unidad 6 - Consonantes
        </div>
        <div class="estado">
          Bloqueado
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill" viewBox="0 0 16 16">
            <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
          </svg>
        </div>
      </div>
      
      

      <div class="botonUnidad-b" @click="showPopup()"> 
        <div class="portada">
          <img src="@/assets/images/unidades/unidad-7.png">
        </div>
        <div class="titulo">
          Unidad 7 - Consonante m-p
        </div>
        <div class="estado">
          Bloqueado
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill" viewBox="0 0 16 16">
            <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
          </svg>
        </div>
      </div>



      <div class="botonUnidad-b" @click="showPopup()"> 
        <div class="portada">
          <img src="@/assets/images/unidades/unidad-0.png">
        </div>
        <div class="titulo">
          Unidad 8 - Consonante n-s
        </div>
        <div class="estado">
          Bloqueado
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill" viewBox="0 0 16 16">
            <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
          </svg>
        </div>
      </div>



      <div class="botonUnidad-b" @click="showPopup()"> 
        <div class="portada">
          <img src="@/assets/images/unidades/unidad-0.png">
        </div>
        <div class="titulo">
          Unidad 9 - Consonante l-t
        </div>
        <div class="estado">
          Bloqueado
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill" viewBox="0 0 16 16">
            <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
          </svg>
        </div>
      </div>



      <div class="botonUnidad-b" @click="showPopup()"> 
        <div class="portada">
          <img src="@/assets/images/unidades/unidad-0.png">
        </div>
        <div class="titulo">
          Unidad 10 - Consonante d-f
        </div>
        <div class="estado">
          Bloqueado
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill" viewBox="0 0 16 16">
            <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
          </svg>
        </div>
      </div>



      <div class="botonUnidad-b" @click="showPopup()"> 
        <div class="portada">
          <img src="@/assets/images/unidades/unidad-0.png">
        </div>
        <div class="titulo">
          Unidad 11 - Consonante g-j
        </div>
        <div class="estado">
          Bloqueado
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill" viewBox="0 0 16 16">
            <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
          </svg>
        </div>
      </div>



      <div class="botonUnidad-b" @click="showPopup()"> 
        <div class="portada">
          <img src="@/assets/images/unidades/unidad-0.png">
        </div>
        <div class="titulo">
          Unidad 12 - Consonante b-v
        </div>
        <div class="estado">
          Bloqueado
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill" viewBox="0 0 16 16">
            <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
          </svg>
        </div>
      </div>



      <div class="botonUnidad-b" @click="showPopup()"> 
        <div class="portada">
          <img src="@/assets/images/unidades/unidad-0.png">
        </div>
        <div class="titulo">
          Unidad 13 - Consonante c-z
        </div>
        <div class="estado">
          Bloqueado
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill" viewBox="0 0 16 16">
            <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
          </svg>
        </div>
      </div>



      <div class="botonUnidad-b" @click="showPopup()"> 
        <div class="portada">
          <img src="@/assets/images/unidades/unidad-0.png">
        </div>
        <div class="titulo">
          Unidad 14 - Consonante k-q
        </div>
        <div class="estado">
          Bloqueado
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-lock-fill" viewBox="0 0 16 16">
            <path d="M8 1a2 2 0 0 1 2 2v4H6V3a2 2 0 0 1 2-2zm3 6V3a3 3 0 0 0-6 0v4a2 2 0 0 0-2 2v5a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V9a2 2 0 0 0-2-2z"/>
          </svg>
        </div>
      </div>


    </div>
    
  </div>

  <Popup v-if="TogglePopup" v-on:metodo="cerrarOpcion" :texto="contenidoPopup"/>

</template>

<script>
import Popup from '@/components/Popup.vue'

export default {
  components: {
    Popup
  },
  data () {
    return {
      mostrarInicial: false,
      language: navigator.language,
      showButton: false,
      TogglePopup: false,
      contenidoPopup: 'No disponible aún'
    }
  },
  mounted () {
    // Cambiar titulo de la ventana
    document.title = 'Unidades'

    // Iniciar musica de fondo
    this.playAudio()
  },
  unmounted() {
    // Detener musica de fondo
    this.pauseAudio()
  },
  methods: {
    // Funciones para controlar la musica de fondo
    playAudio () {
      try {
        const url = 'https://firebasestorage.googleapis.com/v0/b/spanish-ova-funifelt.appspot.com/o/bgm.mp3?alt=media&token=e7182d2a-439e-45d4-a31b-2d9c754b6644'
        this.audio = new Audio(url)
        this.audio.loop = true
        this.audio.currentTime = 0
        this.audio.volume = 0.05
        this.audio.play()
      } catch (e) {
        console.log(e)
      }
    },
    pauseAudio () {
      if (this.audio) {
        this.audio.pause()
      }
    },


    // Funciones para controlar el popup
    showPopup () {
      this.TogglePopup = true
    },
    cerrarOpcion () {
      this.TogglePopup = false
    }
  }
}
</script>

<style src="@/assets/css/unidades.css" scoped></style>
